import { render, staticRenderFns } from "./Collage.vue?vue&type=template&id=4d566226"
import script from "./Collage.vue?vue&type=script&lang=js"
export * from "./Collage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports